import { render, staticRenderFns } from "./EditPageDetailsLinkedPages.vue?vue&type=template&id=f9fcb59e&scoped=true&"
import script from "./EditPageDetailsLinkedPages.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsLinkedPages.vue?vue&type=script&lang=js&"
import style0 from "./EditPageDetailsLinkedPages.vue?vue&type=style&index=0&id=f9fcb59e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fcb59e",
  null
  
)

export default component.exports